import { render, staticRenderFns } from "./histoire-de-la-maladie.html?vue&type=template&id=1cf724bf&scoped=true&external"
import script from "./histoire-de-la-maladie.js?vue&type=script&lang=js&external"
export * from "./histoire-de-la-maladie.js?vue&type=script&lang=js&external"
import style0 from "./histoire-de-la-maladie.scss?vue&type=style&index=0&id=1cf724bf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf724bf",
  null
  
)

export default component.exports